import { call, put, select } from 'redux-saga/effects';
import {
  reactivateOrganisationFailure,
  reactivateOrganisationSuccess,
  fetchOrganisationsRequest,
} from '../actions';
import { reactivateOrganisation } from '../api';
import { ReactivateOrganisationRequestAction } from '../types';
import { ApiError, ApiResponse } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn } from 'store/app/actions';
import { getAuthUser, getAuthUserLicence } from 'store/auth/selectors';
import { renderErrorMessage } from 'utils/render-error-message';
import { getCurrentSubscription } from 'store/billing/selectors';
import { getCurrentSubscriptionRequest } from 'store/billing/actions';
import { LicenseStatus } from 'store/app/enums';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* reactivateOrganisationSaga(
  action: ReactivateOrganisationRequestAction
) {
  try {
    let err: ApiError | null;
    const { organisationId } = action.payload;
    const response: ApiResponse = yield call(
      reactivateOrganisation,
      organisationId
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(fetchOrganisationsRequest());
    yield put(reactivateOrganisationSuccess());

    const currentUser = yield select(getAuthUser);

    const currentSubscription = yield select(getCurrentSubscription);
    if (currentUser) {
      const userLicence = yield select(getAuthUserLicence);
      if (currentSubscription && userLicence?.status === LicenseStatus.ACTIVE) {
        yield put(getCurrentSubscriptionRequest(currentUser?.accountUuid));
      }
    }

    const message: MessageData = {
      title: i18n.t('common.success'),
      description: i18n.t('notifications.entity-reactivated-successfully'),
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(reactivateOrganisationFailure());
  }
}
